import { render } from "./FlexShrink.vue?vue&type=template&id=03ba361f&scoped=true&ts=true"
import script from "./FlexShrink.vue?vue&type=script&lang=ts"
export * from "./FlexShrink.vue?vue&type=script&lang=ts"

import "./FlexShrink.vue?vue&type=style&index=0&id=03ba361f&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03ba361f"]])

export default __exports__